'use es6';

import styled from 'styled-components';
import UIPercentageStepper from 'UIComponents/input/UIPercentageStepper';
const PercentageStepperInput = styled(UIPercentageStepper).withConfig({
  displayName: "TablePopoverPercentageStepperInput__PercentageStepperInput",
  componentId: "sc-8lxz2-0"
})(["max-width:", " !important;& input{min-height:32px;}"], ({
  width
}) => width || '100%');
export default PercentageStepperInput;